<template>
  <div class="email-block">
    <h3 class="email-block__title">{{ $t('view.flow.block.email.title') }}</h3>
    <in
      class="email-block__input"
      v-model="val.title"
      :label="$t('view.flow.block.email.mailTitle')"
    ></in>
    <in
      class="email-block__input"
      v-model="recipientsString"
      @input="recipientsChange"
      :label="$t('view.flow.block.email.mailRecipients')"
    ></in>
    <text-editor class="email-editor" @change="textEditorChange" ref="textEditor"></text-editor>
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'

export default {
  components: {
    EditorContent,
  },
  props: ['value', 'blockId'],
  data() {
    return {
      val: null,
      recipientsString: ''
    }
  },

  created() {
    this.val = this.value
    this.recipientsString = this.val.recipients.toString().replace(/,/g, ' ')
  },

  mounted() {
    this.$refs.textEditor.editor.setContent(this.val.content)
  },

  methods: {
    onInput() {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    textEditorChange(state) {
      this.val.content = state
      this.onInput()
    },

    recipientsChange() {
      if (!this.recipientsString) {
        this.val.recipients = []
        return
      }

      this.val.recipients = this.recipientsString.split(/\s+/g).map(v => v.trim()).filter(v => v)
      this.onInput()
    }
  }
}
</script>

<style lang="scss">
.email-block {
  @include flowElementShadow();
  padding: 1px 12px 12px 12px;
  background-color: white;
  border-radius: 7px;
  width: 570px;

  &__input {
    margin-bottom: 8px;
  }
}

.email-editor {
  margin-top: 18px;
}
</style>
